import React from 'react';
import { Box } from '@mui/material';
import { SidebarWidth } from '@europrocurement/flexy-components/assets';
import { ModalMenuItemProps } from '../ModalMenuItem';
import { ModalSidebar } from '../../organisms/ModalSidebar';

export type DesktopSidebarProps = {
    menuItems: ModalMenuItemProps[];
};

/**
 * Sidebar pour desktop et tablet
 * Affiche la structure complète des menus avec headers
 */
export const DesktopSidebar: React.FunctionComponent<DesktopSidebarProps> = function ({
    menuItems,
}) {
    return (
        <Box
            sx={{
                width: `${SidebarWidth}px`,
                height: '100%',
                flexShrink: 0,
            }}
        >
            <ModalSidebar items={menuItems} />
        </Box>
    );
};
